require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var React = _interopRequireWildcard(require("react"));

var _reactNative = require("react-native-web/dist/index");

var _AnimatedText = _interopRequireDefault(require("../../Typography/AnimatedText"));

var _jsxFileName = "/Users/trensik/dev/react-native-paper/src/components/TextInput/Label/LabelBackground.tsx";

var LabelBackground = function LabelBackground(_ref) {
  var parentState = _ref.parentState,
      _ref$labelProps = _ref.labelProps,
      placeholderStyle = _ref$labelProps.placeholderStyle,
      baseLabelTranslateX = _ref$labelProps.baseLabelTranslateX,
      topPosition = _ref$labelProps.topPosition,
      hasActiveOutline = _ref$labelProps.hasActiveOutline,
      label = _ref$labelProps.label,
      backgroundColor = _ref$labelProps.backgroundColor,
      labelStyle = _ref.labelStyle;
  var hasFocus = hasActiveOutline || parentState.value;
  var opacity = parentState.labeled.interpolate({
    inputRange: [0, 1],
    outputRange: [hasFocus ? 1 : 0, 0]
  });
  var labelTranslationX = {
    transform: [{
      translateX: parentState.labeled.interpolate({
        inputRange: [0, 1],
        outputRange: [-baseLabelTranslateX, 0]
      })
    }]
  };
  return label ? [React.createElement(_reactNative.Animated.View, {
    key: "labelBackground-view",
    pointerEvents: "none",
    style: [_reactNative.StyleSheet.absoluteFill, styles.view, {
      backgroundColor: backgroundColor,
      opacity: opacity
    }, labelTranslationX],
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39
    }
  }), React.createElement(_AnimatedText["default"], {
    key: "labelBackground-text",
    style: [placeholderStyle, labelStyle, styles.outlinedLabel, {
      top: topPosition + 1,
      backgroundColor: backgroundColor,
      opacity: opacity,
      transform: [].concat((0, _toConsumableArray2["default"])(labelStyle.transform), [{
        scaleY: parentState.labeled.interpolate({
          inputRange: [0, 1],
          outputRange: [0.2, 1]
        })
      }])
    }],
    numberOfLines: 1,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52
    }
  }, label)] : null;
};

var _default = LabelBackground;
exports["default"] = _default;

var styles = _reactNative.StyleSheet.create({
  view: {
    position: 'absolute',
    top: 6,
    left: 10,
    width: 8,
    height: 2
  },
  outlinedLabel: {
    position: 'absolute',
    left: 18,
    paddingHorizontal: 0,
    color: 'transparent'
  }
});